define(['jquery', "waypoints"],
    function($, waypoints) {
        var jumpNav = {
            $jumpLink:'',
            $header:'',
            $section:'',
            Init: function () {
                //declare vars
                this.$header = $('.landing__nav');
                this.$jumpLink = $('.landing__menu__link');
                this.$sectionId = $('.landing').find('section[id]');


                if (jumpNav.$jumpLink.length) {
                    jumpNav.$jumpLink.on('click', jumpNav.jumpLinks);
                }
                if (jumpNav.$sectionId.length) {
                    //log('test');
                    jumpNav.$sectionId.each(function () {
                        var waypoint = new Waypoint({
                            element: $(this),
                            handler: function (direction) {
                                $('.landing__menu__link--active').removeClass('landing__menu__link--active');
                                $('.landing__menu__link[href="#'+this.element[0].id+'"]').addClass('landing__menu__link--active');
                                // log(this.element[0].id);
                                // log(this.element.id + 'triggers at ' + direction)
                            },
                            offset: 150
                        });
                    });
                }
            },
            jumpScroll: function (scrollVar) {
                if (!scrollVar || scrollVar == '#' || scrollVar == '##') {
                    return;
                }

                var $where = $(scrollVar);
                var whereTo = $where.offset().top - 150;

                $('html, body').animate({
                    scrollTop: whereTo
                }, 500, 'swing');

                $where.attr('tabindex', -1).addClass('removetabindex').focus();
            },

            jumpLinks: function() {
                var where = $(this).attr('href');

                jumpNav.jumpScroll(where);
            }
        }
        return jumpNav;
    }
);